import React, { useState, useEffect, useReducer } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Row,
  Col,
  Uploader,
  Icon,
  Table,
  ButtonGroup,
  IconButton,
  Input,
  Message,
  Loader,
  Whisper,
  Popover,
} from 'rsuite'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import classNames from 'classnames'
import { v4 as uuidv4 } from 'uuid'
import notification from '../../utils/notification'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { doneLoading, startLoading } from '../../utils/loading'
import { cloneDeep, isEmpty } from 'lodash-es'
import {
  deleteInfomaDocumentById,
  downloadFileByPath,
  getInfomaDocumentPage,
  saveInfomaDocument,
  sendFileToInfoma,
} from '../../redux/actions/infomaDocument'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'

export default function InfomaUploadFilesWidget({
  schema,
  header,
  isContract,
  disabledForm,
  isStaff,
  onValidateFile = () => {},
  onUploadError = () => {},
  onUploadSuccess = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(schema)
  const [attachFiles, setAttachFiles] = useState([])
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [deleteObj, setDeleteObj] = useState()
  const { errors, control } = useForm()
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [rowDataItem, setRowDataItem] = useState(false)
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [showConfirmSend, setShowConfirmSend] = useState(false)
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  useEffect(() => {
    if (schema) {
      setFormSchema(schema)
    }
  }, [schema])

  useEffect(() => {
    console.log('schema.attachFiles', schema.attachFiles)
    if (schema?.attachFiles?.value?.length > 0) {
      setAttachFiles([...(schema.attachFiles.value || [])])

      let listId = []
      schema.attachFiles.value.forEach((item) => {
        if (item.id) {
          listId.push(item.id)
        }
      })
      setExpandedRowKeys(listId)
    }
  }, [schema.attachFiles])

  useEffect(() => {
    setTimeout(() => {
      if (isFirstLoad) {
        setExpandedRowKeys([])
        setIsFirstLoad(false)
      }
    }, 100)
  }, [expandedRowKeys])

  useEffect(() => {
    setTimeout(() => {
      forceUpdate()
    }, 100)
  }, [schema])

  const onAddfileType = (rowData) => {
    var _attachFiles = cloneDeep(attachFiles)
    var newAttachFiles = []
    newAttachFiles = _attachFiles.map((element) => {
      if (element.id == rowData.masterCategoryId) {
        var _data = {
          id: 'add-' + uuidv4(),
          documentId: rowData.documentId,
          documentName: 'แนบเอกสารอื่นเพิ่มเติม',
          //enableDelete: true,
          //isRequired: true,
          //isValidated: false,
          //label: '',
          documentFileName: '',
          documentFilePath: '',
          documentType: '9',
          documentTypeName: 'แนบเพิ่ม',
          documentStatusCode: 0,
          documentStatusName: 'รอส่ง',
          masterCategoryId: rowData.masterCategoryId,
          isLastRow: false,
          isEdit: true,
        }
        //element.children.push(_data)
        element.children.splice(element.children.length - 1, 0, _data)
        return element
      } else {
        return element
      }
    })
    console.log('newAttachFiles', newAttachFiles)
    setAttachFiles(newAttachFiles)
  }

  const onDeleteAddFile = (rowData, index) => {
    var _attachFiles = cloneDeep(attachFiles)
    var newAttachFiles = []
    newAttachFiles = _attachFiles.map((element) => {
      if (element.id == rowData?.masterCategoryId) {
        let deleteIndex = element.children.findIndex((e) => e.id == rowData.id)
        element.children.splice(deleteIndex, 1)
        return element
      } else {
        return element
      }
    })
    console.log('newAttachFiles', newAttachFiles)
    setAttachFiles(newAttachFiles)
  }

  const setRowData = (rowData, newData) => {
    setAttachFiles((state) => {
      return state.map((item) => {
        if (item.id === rowData.masterCategoryId) {
          item.children = item.children?.map((element) => {
            if (element.id === rowData.id) {
              return {
                ...element,
                ...newData,
              }
            } else {
              return element
            }
          })
        }
        return item
      })
    })
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      console.log('call delete.')
      const response = await saveInfomaDocument(projectId, request)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        let res = await getInfomaDocumentPage(projectId)
        setAttachFiles([...(res?.model?.forms?.attachFiles?.value || [])])
      } else {
        notification.open('error', {
          title: response.model.errorMessage || DEFAULT_ERR_MSG,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    try {
      console.log('call delete.')
      const response = await deleteInfomaDocumentById(id)
      if (response) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
        })
        let res = await getInfomaDocumentPage(projectId)
        console.log('response', res)
        setAttachFiles([...(res?.model?.forms?.attachFiles?.value || [])])
      } else {
        notification.open('error', {
          title: response.model.errorMessage || 'ลบรายการไม่สำเร็จ',
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'ลบรายการไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnSendInfoma = async (rowData) => {
    startLoading()
    setIsLoading(true)
    try {
      let request = {
        //id: rowData.id, //"61CA1906-80AF-4C8A-8843-BBF635E8595C",
        projectVersionId: projectId, //"61CA1906-80AF-4C8A-8843-BBF635E8595C",
        documentFileName: rowData.documentFileName, //"examplePDF.pdf",
        documentFilePath: rowData.documentFilePath, //"another-upload-file/5F1ABB18-2A54-4928-A88E-A3C3C2A4985C.pdf",
        documentId: rowData.documentId, //"1014",
        documentName: rowData.documentName, //"แบบกลั่นกรองโครงการ อ.8",
        documentType: rowData.documentType, //"1",
        documentTypeName: rowData.documentTypeName, //"แนบเพิ่ม",
      }

      const response = await sendFileToInfoma(rowData.id, request)

      if (response.isSuccess) {
        notification.open('success', {
          title: 'ส่งสำเร็จ',
        })
        let res = await getInfomaDocumentPage(projectId)
        setAttachFiles([...(res?.model?.forms?.attachFiles?.value || [])])
      } else {
        notification.open('error', {
          title: response.message || DEFAULT_ERR_MSG,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadFileByPath(fileObj.documentFilePath)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.documentName)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'ดาวน์โหลดไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadFileByPath(fileObj.documentFilePath)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.documentName)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'แสดงไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleOnSave = (rowData) => {
    console.log('rowData', rowData)
    const formData = new FormData()

    rowData.files &&
      rowData.files?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('FileId', rowData.id.indexOf('add-') != -1 ? '' : rowData.id)
    formData.append('DocumentId', rowData.documentId || '')
    formData.append('DocumentName', rowData.documentName || '')
    formData.append('DocumentType', rowData.documentType || '')
    formData.append('IsDeleteFile', rowData.isDeleteFile ? true : false)

    console.log('formData', formData)
    handleUpload(formData)
  }

  return (
    <Panel shaded header={header || formSchema?.forms?.attachFiles.header}>
      {!disabledForm && (
        <Message
          showIcon
          type="info"
          description={'ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf ขนาดไฟล์ไม่เกิน 50 MB'}
        />
      )}

      {formSchema?.attachFiles?.description && (
        <Row style={{ marginTop: 10 }}>
          <CustomIconMessageInfo contents={formSchema.attachFiles.description} />
        </Row>
      )}

      <Row style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Table
            autoHeight
            height={300}
            wordWrap
            bordered
            data={attachFiles}
            isTree
            defaultExpandAllRows
            rowKey="id"
            expandedRowKeys={expandedRowKeys}
            onExpandChange={(expanded, rowData) => {
              if (expanded) {
                setExpandedRowKeys((state) => [...state, rowData.id])
              } else {
                setExpandedRowKeys((state) => state.filter((item) => item !== rowData.id))
              }
            }}
          >
            <Column width={100} colSpan={3}>
              <HeaderCell>หมวดหมู่</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.category) {
                    return rowData.category
                  }
                }}
              </Cell>
            </Column>

            <Column minWidth={300} flexGrow={1}>
              <HeaderCell>เอกสารประกอบ</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.isEdit && rowData.documentType == 9) {
                    return (
                      <Controller
                        name={`documentName_${rowData.id}`}
                        control={control}
                        defaultValue={rowData.documentName}
                        rules={{ required: 'กรุณากรอก' }}
                        render={(props) => {
                          return (
                            <Input
                              className={classNames('rs-input', errors[rowData.id] && 'is-error')}
                              placeholder="ระบุชื่อเอกสาร"
                              value={props.value}
                              onChange={(e) => {
                                props.onChange(e)
                                setRowData(rowData, {
                                  documentName: e,
                                })
                              }}
                            />
                          )
                        }}
                      />
                    )
                  } else if (rowData.documentName) {
                    return <span>{rowData.documentName}</span>
                  } else {
                    return
                  }
                }}
              </Cell>
            </Column>

            <Column width={150} align="center">
              <HeaderCell>ประเภทเอกสาร</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.documentTypeName) {
                    return rowData.documentTypeName
                  }
                }}
              </Cell>
            </Column>

            <Column width={109} align="center">
              <HeaderCell>สถานะ</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.documentStatusName && rowData.documentFilePath) {
                    return rowData.documentStatusName
                  }
                }}
              </Cell>
            </Column>

            <Column width={130} align="center">
              <HeaderCell>แนบเอกสาร</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (rowData.documentFilePath && !rowData.isDeleteFile) {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={(e) => onPreview(rowData)}
                          disabled={isLoading}
                        />
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          onClick={(e) => onDownload(rowData)}
                          disabled={isLoading}
                        />

                        {!disabledForm && rowData.documentType != 0 && rowData.isEdit && (
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-cancel"
                            icon={
                              <Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />
                            }
                            onClick={(e) => {
                              setRowData(rowData, {
                                isDeleteFile: true,
                              })
                            }}
                            //disabled={!rowData.enableDelete || rowData.isChecked}
                          />
                        )}
                      </ButtonGroup>
                    )
                  } else if (rowData.isEdit) {
                    return (
                      !disabledForm && (
                        <>
                          {rowData.isLoading && <Loader backdrop center />}
                          <Controller
                            name={`file_${rowData.id}`}
                            control={control}
                            defaultValue={!isEmpty(rowData.value) ? [rowData.value] : undefined}
                            // rules={isValidators(attachmentSchema.validators)}
                            render={(props) => {
                              if (props.value) {
                                console.log('props', props)
                                return (
                                  <div
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    <p>{props?.value[0]?.name || 'file name'}</p>

                                    <IconButton
                                      appearance="link"
                                      //className="rs-btn-ghost-cancel"
                                      icon={<Icon icon="close" style={{ color: 'gray' }} />}
                                      onClick={(e) => {
                                        let files = []
                                        //files.push(fileList[fileList.length - 1])
                                        props.onChange()
                                        setRowData(rowData, {
                                          files: undefined,
                                        })
                                      }}
                                      //disabled={!rowData.enableDelete || rowData.isChecked}
                                    />
                                  </div>
                                )
                              } else {
                                return (
                                  <Uploader
                                    accept=".jpg, .jpeg, .png, .pdf"
                                    draggable
                                    autoUpload={false}
                                    multiple={false}
                                    listType="picture"
                                    fileList={props.value || []}
                                    onChange={(fileList) => {
                                      if (isEmpty(fileList)) {
                                        props.onChange(undefined)

                                        setRowData(rowData, {
                                          files: undefined,
                                        })
                                      } else {
                                        let files = []
                                        files.push(fileList[fileList.length - 1])
                                        props.onChange(files)

                                        setRowData(rowData, {
                                          files: files,
                                        })
                                      }
                                    }}
                                  >
                                    <button className="upload__button" style={{ marginTop: 0 }}>
                                      <Icon icon="upload" size="lg" />
                                    </button>
                                  </Uploader>
                                )
                              }
                            }}
                          />
                        </>
                      )
                    )
                  } else if (rowData.isLastRow && !disabledForm) {
                    return (
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="plus" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => onAddfileType(rowData)}
                        disabled={isLoading}
                      >
                        เพิ่ม
                      </IconButton>
                    )
                  }
                }}
              </Cell>
            </Column>
            {!disabledForm && (
              <Column width={150}>
                <HeaderCell>จัดการ</HeaderCell>
                <Cell style={{ marginRight: 20 }}>
                  {(rowData, index) => {
                    if (rowData.isEdit) {
                      return (
                        <>
                          <Whisper
                            placement="top"
                            trigger="hover"
                            speaker={<Popover>บันทึก</Popover>}
                          >
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost"
                              style={{ marginBottom: 0 }}
                              icon={<Icon icon="save" className="bt-gost-icon-none-radius" />}
                              onClick={(e) => {
                                handleOnSave(rowData)
                              }}
                              disabled={isLoading}
                              //onClick={(e) => onDeleteAddFile(rowData, index)}
                              // disabled={!rowData.enableDelete || rowData.isChecked}
                            />
                          </Whisper>
                          <Whisper
                            placement="top"
                            trigger="hover"
                            speaker={<Popover>ยกเลิก</Popover>}
                          >
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              style={{ marginBottom: 0 }}
                              icon={
                                <Icon icon="close" className="bt-gost-icon-none-radius-cancel" />
                              }
                              onClick={(e) => {
                                setRowData(rowData, {
                                  isEdit: false,
                                  isDeleteFile: false,
                                })
                              }}
                              disabled={isLoading}
                              // disabled={!rowData.enableDelete || rowData.isChecked}
                            />
                          </Whisper>
                        </>
                      )
                    } else {
                      return (
                        <>
                          {(rowData.documentType == 9 || rowData.documentType == 1) &&
                            rowData.documentStatusCode != 1 && (
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={<Popover>แก้ไข</Popover>}
                              >
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-edit"
                                  style={{ marginBottom: 0 }}
                                  icon={
                                    <Icon icon="edit" className="bt-gost-icon-none-radius-edit" />
                                  }
                                  onClick={(e) => {
                                    console.log('edit')
                                    setRowData(rowData, {
                                      isEdit: true,
                                    })
                                  }}
                                  disabled={isLoading}
                                  //onClick={(e) => onDeleteAddFile(rowData, index)}
                                  // disabled={!rowData.enableDelete || rowData.isChecked}
                                />
                              </Whisper>
                            )}

                          {(rowData.documentType == 9 || rowData.documentType == 1) && (
                            //rowData.documentStatusCode != 1 && (
                            <Whisper
                              placement="top"
                              trigger="hover"
                              speaker={<Popover>ลบรายการ</Popover>}
                            >
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost-cancel"
                                style={{ marginBottom: 0 }}
                                icon={
                                  <Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />
                                }
                                onClick={(e) => {
                                  if (rowData.id.indexOf('add-') != -1) {
                                    onDeleteAddFile(rowData, index)
                                  } else {
                                    setDeleteObj(rowData)
                                    setShowConfirmDelete(true)
                                  }
                                }}
                                disabled={isLoading}
                                // disabled={!rowData.enableDelete || rowData.isChecked}
                              />
                            </Whisper>
                          )}

                          {rowData.documentFilePath && rowData.documentStatusCode != 1 && (
                            <Whisper
                              placement="top"
                              trigger="hover"
                              style={{ marginLeft: 5 }}
                              speaker={<Popover>ส่งไปยังระบบ Infoma</Popover>}
                            >
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost"
                                style={{ marginBottom: 0, float: 'right' }}
                                icon={<Icon icon="send" className="bt-gost-icon-none-radius" />}
                                onClick={(e) => {
                                  //console.log('rowData', rowData)
                                  setRowDataItem(rowData)
                                  setShowConfirmSend(true)
                                }}
                                disabled={isLoading}
                                // disabled={!rowData.enableDelete || rowData.isChecked}
                              />
                            </Whisper>
                          )}
                        </>
                      )
                    }
                  }}
                </Cell>
              </Column>
            )}
          </Table>
        </Col>
      </Row>
      {/* </Panel> */}

      <ConfirmWidget
        size={'sm'}
        title={`ยืนยันการลบ`}
        show={showConfirmDelete}
        detail={
          <span>
            {deleteObj?.documentStatusCode == 1
              ? `รายการนี้ส่งไประบบจัดเก็บเอกสาร (INFOMA) เรียบร้อยแล้ว ยืนยันที่จะลบรายการหรือไม่ ? `
              : `ยืนยันการลบรายการ`}
          </span>
        }
        onCancle={() => {
          setShowConfirmDelete(false)
          setDeleteObj('')
        }}
        onConfirm={() => {
          setShowConfirmDelete(false)
          handleDelete(deleteObj?.id)
        }}
      />

      <ConfirmWidget
        size={'md'}
        title={`ส่งไฟล์ไปยังระบบ Infoma`}
        show={showConfirmSend}
        detail={
          <span>
            กรุณาตรวจสอบไฟล์ก่อนกดยืนยันการส่ง หากส่งสำเร็จแล้ว ท่านจะ{' '}
            <u style={{ color: 'red' }}>ไม่สามารถแก้ไข</u> รายการได้
            หากต้องการปรับเปลี่ยนต้องลบและแนบไฟล์ใหม่เท่านั้น
          </span>
        }
        onCancle={() => setShowConfirmSend(false)}
        onConfirm={() => {
          handleOnSendInfoma(rowDataItem), setShowConfirmSend(false)
        }}
      />
    </Panel>
  )
}
